/* ARCELF — Hero
   - measure sticky header height → set --header-h on each hero (so hero block fits below header)
   - slideshow rotation (configurable interval, pauses when tab hidden or hero off-screen)
   - is-scrolled state on <html>: toggled when window has scrolled past the top
       drives the CSS transition that shrinks the fixed wordmark from 740 → 110 (and back)
   - smooth-scroll for in-page anchors (back to top)
*/
(function () {
  'use strict';

  const heroes = document.querySelectorAll('[data-arcelf-hero]');
  if (heroes.length) {
    /* トップ（ヒーローのあるページ）では、巨大ワードマークと被るため
       ヘッダー左上の小ロゴを最上部では出さない（is-scrolled 後にフェードイン）。
       9/28 FB④: 下層ページの静止ヒーロー（.arcelf-hero--static）では付けない＝ヘッダーのロゴは最初から出す */
    if (document.querySelector('[data-arcelf-hero]:not(.arcelf-hero--static)')) {
      document.documentElement.classList.add('arcelf-has-hero');
    }
    heroes.forEach(initHero);
  }

  /* ============================================================
     is-scrolled state — single source of truth for the wordmark morph
     ============================================================ */
  const SCROLL_THRESHOLD = 1; // px — any scroll triggers the morph
  let lastScrolled = null;
  const updateScrollState = () => {
    const scrolled = window.scrollY > SCROLL_THRESHOLD;
    if (scrolled === lastScrolled) return;
    lastScrolled = scrolled;
    document.documentElement.classList.toggle('is-scrolled', scrolled);
  };
  window.addEventListener('scroll', updateScrollState, { passive: true });
  updateScrollState();

  /* ============================================================
     SP だけ、ワードマークの縮小をスクロール量に連動させる（9/10 藤井指示）
     PC は従来どおり is-scrolled をトリガーにした時間ベースの transition。
     SP は「ひと転がりで縮みきる」のではなく、指を動かした分だけ縮む。
     進捗 --p（0→1）を hero に書き込み、変形の計算は CSS 側が持つ。
     ============================================================ */
  (function scrollMorph() {
    const hero = document.querySelector('.arcelf-hero:not(.arcelf-hero--static)'); /* 静止ヒーローは縮めない */
    if (!hero) return;
    const mq = window.matchMedia('(max-width: 749px)');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    /* 縮みきるまでの距離。画面高に比例させ、端末が変わっても体感を揃える */
    let distance = Math.max(220, Math.round(window.innerHeight * 0.45));
    let ticking = false;

    const apply = () => {
      ticking = false;
      if (!mq.matches || reduce.matches) {
        hero.style.removeProperty('--p');
        return;
      }
      const y = Math.max(0, window.pageYOffset || 0);
      const p = Math.min(1, y / distance);
      hero.style.setProperty('--p', p.toFixed(4));
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(apply); } };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      distance = Math.max(220, Math.round(window.innerHeight * 0.45));
      apply();
    }, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', apply);
    apply();
  })();

  /* ============================================================
     smooth-scroll for in-page anchors

     以前は a[href^="#"] を全部横取りしていたが、これには2つの実害があった。
     ① このファイルは全ページで読まれるため、ヒーローが無いページでも発火し、
        スキップリンク（#MainContent）まで preventDefault してフォーカス移動を殺していた。
     ② back to top（#arcelf-top）も奪い、レイアウトボックスを持たない空の span に
        scrollIntoView を投げて何も起きない状態を作っていた。
        arcelf-interactions.js 側の専用ハンドラと二重に走って打ち消し合ってもいた。

     → 対象を「実体のあるアンカー」に限定し、#arcelf-top とスキップリンクは
        それぞれの正しい担当（interactions.js / ブラウザ標準）に任せる。
     ============================================================ */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href || href === '#') return;
    if (href === '#arcelf-top') return;   /* back to top は interactions.js が担当 */
    if (href === '#MainContent') return;  /* スキップリンクはブラウザ標準に任せる */
    const target = document.querySelector(href);
    if (!target) return;
    /* 高さも幅も無い要素は scrollIntoView が無反応なので、横取りしない */
    const r = target.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.pushState) history.pushState(null, '', href);
  });

  function initHero(hero) {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* --- measure sticky header → expose as --header-h on the hero --- */
    const header = document.querySelector('.arcelf-header--sticky') || document.querySelector('.arcelf-header');
    const updateHeaderVar = () => {
      const h = header ? header.getBoundingClientRect().height : 0;
      hero.style.setProperty('--header-h', `${Math.round(h)}px`);
    };
    updateHeaderVar();
    window.addEventListener('resize', updateHeaderVar);
    if ('ResizeObserver' in window && header) {
      new ResizeObserver(updateHeaderVar).observe(header);
    }

    /* --- slideshow --- */
    const slides = Array.from(hero.querySelectorAll('.arcelf-hero-slide'));
    if (slides.length > 1) {
      const styleInterval = parseInt(getCSSVar(hero, '--hero-slide-interval'), 10);
      const interval = Number.isFinite(styleInterval) && styleInterval > 1000 ? styleInterval : 6000;
      let current = 0;
      let timer = null;

      const advance = () => {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      };

      /* 入場演出: 黒いまま待つ時間（CSS の --hero-entrance-hold が単一ソース）。
         カバーが晴れた瞬間からスライドの5秒カウントが始まるよう、
         初回だけローテーション開始をその分だけ遅らせる。 */
      const holdRaw = parseInt(getCSSVar(hero, '--hero-entrance-hold'), 10);
      let firstHold = !prefersReduced && Number.isFinite(holdRaw) && holdRaw > 0 ? holdRaw : 0;

      let holdTimer = null;
      const start = () => {
        if (timer || holdTimer || prefersReduced) return;
        if (firstHold > 0) {
          holdTimer = window.setTimeout(() => {
            holdTimer = null;
            firstHold = 0;
            timer = window.setInterval(advance, interval);
          }, firstHold);
          return;
        }
        timer = window.setInterval(advance, interval);
      };
      const stop = () => {
        if (holdTimer) { window.clearTimeout(holdTimer); holdTimer = null; }
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      };

      start();

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop(); else start();
      });

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(entries => {
          entries.forEach(e => { e.isIntersecting ? start() : stop(); });
        }, { rootMargin: '0px 0px -20% 0px' });
        io.observe(hero);
      }
    }

    /* scroll-morph(--p) は 8/19 に廃止。
       ロゴ縮小は html.is-scrolled をトリガーにした CSS transition が担当 */
  }

  function getCSSVar(el, name) {
    return getComputedStyle(el).getPropertyValue(name).trim();
  }
})();
